import React, { useEffect, useState } from 'react';
import { Button, Confirm, Grid, Header, Icon, Loader, Modal, Popup } from 'semantic-ui-react';
import { Auth } from 'aws-amplify';
import RecipientContainer from '../../Components/Home/Recipient/Container/Container';
import ScoreContainer from '../../Components/Home/AgeReadyScore/ScoreContainer/ScoreContainer';
import styles from './Home.module.css';
import { useHistory } from 'react-router';
import { useAgeReadyContext } from '../../AgeReadyContext/AgeReadyContext';
import { observer } from 'mobx-react-lite';
import { IRecipientModel, IRecipientModelSnapshotIn } from '../../Models/Recipient';
import RecipientForm from '../../Components/Questionnaire/RecipientForm';

const DashboardPage: React.FC = () => {
  const history = useHistory();
  const [givenName, setGivenName] = useState<string>('');
  const [userId, setUserId] = useState<string>('');
  const [selectedRecipient, setSelectedRecipient] = useState<IRecipientModel | undefined>(undefined);
  const { caregiverStore } = useAgeReadyContext();
  const [recipients, setRecipients] = useState<IRecipientModel[]>([]);
  const [viewEditRecipient, setViewEditRecipient] = useState(false);
  const [viewDeleteRecipientConfirmation, setViewDeleteRecipientConfirmation] = useState(false);
  const [onConfirmDeleteLoading, setOnConfirmDeleteLoading] = useState(false);

  useEffect(() => {
    Auth.currentUserInfo().then((userInfo) => {
      const { attributes = {} } = userInfo;
      setGivenName(attributes['given_name']);
      setUserId(attributes['sub']);
    });

    const newRecipients = caregiverStore.recipients;
    setRecipients(newRecipients);
  }, [
    caregiverStore.recipients,
    history,
    caregiverStore.partnerCode,
    caregiverStore,
  ]);

  const onRecipientSelected = (recipient: IRecipientModel | undefined) => {
    setSelectedRecipient(recipient);
  };

  const onAddRecipient = () => {
    history.push('/add-recipient');
  };

  const onCancelRecipientEditClick = () => {
    setViewEditRecipient(false);
  };

  const onUpdateRecipientHandler = async (updatedRecipient: IRecipientModelSnapshotIn) => {
    const userInfo = await Auth.currentAuthenticatedUser();
    setUserId(userInfo.username);
    await caregiverStore.saveRecipient(userInfo.username, updatedRecipient);
    setViewEditRecipient(false);
  };

  const onEditRecipientClick = () => {
    setViewEditRecipient(true);
  }

  const editRecipientForm = () =>  {
    if (viewEditRecipient) {
      return (
      <>
      <Modal open={true} style={{ borderRadius: 40, padding: 0, background: 'transparent', boxShadow: 'none' }}>
        <RecipientForm
          data-testid='newRecipientForm'
          isLoading={false}
          cancelButtonLabel='Cancel'
          formType='Edit'
          selectedRecipient={selectedRecipient}
          onSaveClick={async ( updatedRecipient: IRecipientModelSnapshotIn ) => {onUpdateRecipientHandler(updatedRecipient) }}
          onCancelClick={onCancelRecipientEditClick}
        />
      </Modal>
      </>
    )}
  }

  const onDeleteRecipientClick = () => {
    setViewDeleteRecipientConfirmation(true);
  }
  const onDeleteRecipientConfirmClick = async () => {
    setOnConfirmDeleteLoading(true);
    const userInfo = await Auth.currentAuthenticatedUser();
    setUserId(userInfo.username);
    await caregiverStore.deleteRecipient(userInfo.username, selectedRecipient?.id);
    setViewDeleteRecipientConfirmation(false);
    setOnConfirmDeleteLoading(false);
    setSelectedRecipient(undefined);
  }
  const onDeleteRecipientCancelClick = () => {
    setViewDeleteRecipientConfirmation(false);
  }
  const deleteRecipientConfirmation = () => {
    if(viewDeleteRecipientConfirmation) {
      return (
        <>
        <Confirm
          className={styles['confirmation_cta']}
          open={true}
          confirmButton={{ content: "Yes", loading: onConfirmDeleteLoading }}
          cancelButton={{ content: "Cancel" }}
          onConfirm={onDeleteRecipientConfirmClick}
          onCancel={onDeleteRecipientCancelClick}
          header="Delete Recipient Confirmation"
          content="Are you sure you want to permanently delete this Recipient?"
        />
        </>
      )
    }
  }

  return (
    <>
      {!givenName && <Loader active={!givenName} />}
      {givenName && (        
        <Grid style={{ flex: 1, }}>
          <div style={adminButtonStyles}>
            <Header style={{ color: '#333B4C', fontSize: '30px', }} >
              Welcome, {givenName}!
            </Header> 
            <Popup trigger= {
                <Button onClick={onAddRecipient} icon labelPosition='left' positive style={{margin: 0}}>
                <Icon name='plus' />  Add Recipient </Button>
              }
              content='A Recipient could be a loved one, an individual you are caring for, or yourself.'
              position='right center'
            />
          </div>

        
              <div
                style={{ padding: '1em' }}
                className={styles.recipientContainer}
              >
                {recipients.length > 0 && (
                  <RecipientContainer
                    recipients={recipients}
                    onRecipientSelected={onRecipientSelected}
                    selectedRecipient={selectedRecipient}
                    onEditClick={onEditRecipientClick}
                    onDeleteClick={onDeleteRecipientClick}
                  />
                )}
              </div>
           

        {deleteRecipientConfirmation()}
        {editRecipientForm()}
        {selectedRecipient && (
          <>
           
              <ScoreContainer
                // Can I create a context instead of passing this all down?
                selectedRecipient={selectedRecipient}
                caregiverId={userId}
              />
          </>
        )}
        </Grid>
      )}
    </>
  );
};

const adminButtonStyles = {
  marginTop: '20px',
  marginBottom: '20px',
};

export default observer(DashboardPage);
